export default "__VITE_ASSET__BRvoGWKR__"